import { useMeleeContext } from 'draft/context/MeleeContextProvider'
import React from 'react'
import { Divider, Grid, Image } from 'semantic-ui-react'

import fyllameleeLogo from '../assets/logo.png'
import dridasLogo from '../assets/dridas_vm_logo.png'
import smashedLogo from '../assets/smashed_silver_logo.png'

import { GameType } from 'draft/types'
import { useNavigate } from 'react-router-dom'

import { Brand, getBrand } from '../common/brand'

type Props = {
  rightMenu?: JSX.Element,
  helmet?: string
  hideDivider?: boolean;
}

const draftHeader = {
  padding: '1em 0px'
}


const Header = ({ rightMenu, helmet, hideDivider }: Props) => {
  const navigate = useNavigate();
  const meleeContext = useMeleeContext();

  const showDridasLogo = false;


  if (helmet) {
    document.title = getBrand();
  }

  const getLogo = () => {
    if (getBrand() === Brand.Fyllamelee) {
      return fyllameleeLogo;
    }
    return smashedLogo;
  }


  return (
    <>
      <Grid style={draftHeader} centered columns={3} container stackable>
        <Grid.Column>
        </Grid.Column>
        <Grid.Column textAlign='center'>
          {showDridasLogo && meleeContext?.draftOptions && meleeContext?.draftOptions.gameType === GameType.Ultimate ? (
            <Image
              src={dridasLogo}
              alt="main logo"
              size='large'
              centered
              onClick={() => { navigate('/') }}
              className={'basic-clickable'} />
          ) : (

            <Image
              src={getLogo()}
              alt="main logo"
              size='medium'
              centered
              onClick={() => { navigate('/') }}
              className={'basic-clickable'}
            />
          )
          }
        </Grid.Column>

        <Grid.Column verticalAlign='middle'>
          {rightMenu}
        </Grid.Column>
      </Grid>
      {!hideDivider &&
        <Divider />
      }

    </>
  )
}

export default Header;
